interface IconProps {
  className?: string;
}

export const PerformanceIcon = ({ className = '' }: IconProps) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 6L27.5 16.5L38 20L27.5 23.5L24 34L20.5 23.5L10 20L20.5 16.5L24 6Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 38L17.5 42L21 43.5L17.5 45L16 49L14.5 45L11 43.5L14.5 42L16 38Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35 32L36 35L39 36L36 37L35 40L34 37L31 36L34 35L35 32Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StrategyIcon = ({ className = '' }: IconProps) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="24"
      cy="24"
      r="18"
      stroke="currentColor"
      strokeWidth="2"
    />
    <circle
      cx="24"
      cy="24"
      r="12"
      stroke="currentColor"
      strokeWidth="2"
    />
    <circle
      cx="24"
      cy="24"
      r="6"
      stroke="currentColor"
      strokeWidth="2"
    />
    <circle
      cx="24"
      cy="24"
      r="2"
      fill="currentColor"
    />
    <path
      d="M24 6V2M24 46V42M42 24H46M2 24H6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const QAConsultingIcon = ({ className = '' }: IconProps) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 8H40V32H16L8 40V8Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M14 18H34M14 24H28"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const AutomationIcon = ({ className = '' }: IconProps) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="14"
      y="6"
      width="20"
      height="28"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M20 12H28M20 17H28M20 22H28"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="24" cy="38" r="4" stroke="currentColor" strokeWidth="2" />
    <path
      d="M24 34V30M20 38H12M28 38H36"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const DevOpsIcon = ({ className = '' }: IconProps) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 10C16.268 10 10 16.268 10 24C10 31.732 16.268 38 24 38C31.732 38 38 31.732 38 24"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M38 24C38 16.268 31.732 10 24 10"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeDasharray="4 4"
    />
    <path
      d="M28 18L34 24L28 30"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ConsultingIcon = ({ className = '' }: IconProps) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="10"
      y="12"
      width="28"
      height="30"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M16 6V12M32 6V12M10 20H38"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M16 26H22M16 32H26"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const TrainingIcon = ({ className = '' }: IconProps) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 18L24 10L40 18L24 26L8 18Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M8 26L24 34L40 26"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 34L24 42L40 34"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WritingIcon = ({ className = '' }: IconProps) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 40H40"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M10 32L34 8L40 14L16 38L10 32Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M30 12L36 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const AccessibilityIcon = ({ className = '' }: IconProps) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="24"
      cy="12"
      r="4"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M14 20H34M24 20V38M18 38L24 32L30 38"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 28C12 28 16 24 24 24C32 24 36 28 36 28"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const getServiceIcon = (service: string) => {
  const iconClass = "service-icon-svg";
  
  switch (service) {
    case 'performance':
      return <PerformanceIcon className={iconClass} />;
    case 'strategy':
      return <StrategyIcon className={iconClass} />;
    case 'qa_strategy_consulting':
      return <QAConsultingIcon className={iconClass} />;
    case 'automation':
      return <AutomationIcon className={iconClass} />;
    case 'devops':
      return <DevOpsIcon className={iconClass} />;
    case 'consulting':
      return <ConsultingIcon className={iconClass} />;
    case 'training':
      return <TrainingIcon className={iconClass} />;
    case 'writing':
      return <WritingIcon className={iconClass} />;
    case 'accessibility':
      return <AccessibilityIcon className={iconClass} />;
    default:
      return <ConsultingIcon className={iconClass} />;
  }
};
